<template>
	<v-dialog v-model="dialog" persistent max-width="80vw">
		<v-btn color="primary" dark slot="activator">Get Approved Leads from Salesforce</v-btn>
		<v-card>
			<v-title>Approved Salesforce Leads</v-title>
			<v-card-title>
				<v-spacer></v-spacer>
				<v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
			</v-card-title>
			<v-data-table
				v-model="selected"
				select-all
				:headers="headers"
				:items="leads"
				:loading="loading"
				:search.sync="search"
				class="elevation-1"
			>
				<template v-slot:items="props">
					<tr :active="props.selected" @click="props.selected = !props.selected">
						<td>
							<v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
						</td>
						<td v-for="prop in headers" :key="prop.id">{{props.item[prop.value]}}</td>
					</tr>
				</template>
			</v-data-table>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					v-if="selected.length > 0"
					color="primary"
					@click.native="dialog = false; $emit('adding',selected);"
				>Add</v-btn>
				<v-btn color="primary" @click.native="dialog = false">Cancel</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "SalesforceLeads",
	data () {
		return {
			search: '',
			keyword: '',
			selected: [],
			dialog: false,
			loading: false,
			headers: [
				{
					text: "Company",
					align: "left",
					sortable: true,
					value: "company"
				},
				{
					text: "Email",
					align: "left",
					sortable: true,
					value: "email"
				},
				{
					text: "Partner Name",
					align: "left",
					sortable: true,
					value: "firstName"
				},
				{
					text: "Mobile Phone",
					align: "left",
					sortable: true,
					value: "mobilePhone"
				}, {
					text: "Post Code",
					align: "left",
					sortable: true,
					value: "postalCode"
				},
			],
			leads: []
		}
	},
	methods: {
		...mapActions('orders/qantas', ['listSalesforceLeads']),
	},
	watch: {
		dialog (a, b) {
			let vm = this;
			if (a)
				vm.loading = true;
			this.listSalesforceLeads().then(data => {
				//Probably a problem with reactivity since it's on watch section (?)
				//Object.assign(vm.leads, data);
				vm.leads = data;
				vm.loading = false;

				/**
				 * Always have empty value everytime search is made.
				 * @ v-text-field (do search) => watch{} => whatever value is made on v-text-field, it will
				 * always be changed to empty. Hence, value will always be empty.
				 */
				//vm.search = ' ';
			})
		}
	}
}
</script>

<style lang="css" scoped>
</style>